const escapeHtml = (value) => String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const formatMoney = (value) => {
    const n = Number(value);
    const safe = Number.isFinite(n) ? n : 0;
    return safe.toFixed(2);
};

/**
 * Opens a print-friendly window with debtors list.
 * Browser "Save as PDF" / Print can be used from there.
 */
export function exportDebtorsPdf(debtors = [], options = {}) {
    const rows = Array.isArray(debtors) ? debtors : [];
    const title = options.title || "Список боржників";
    const networkName = options.networkName || "";
    const generatedAt = new Date().toLocaleString("uk-UA");
    const total = rows.reduce((acc, row) => acc + (Number(row?.debt_amount) || 0), 0);

    const bodyRows = rows.length
        ? rows.map((row, idx) => {
            const meta = [
                row?.location_name,
                row?.apartment ? `кв. ${row.apartment}` : null,
            ].filter(Boolean).join(" · ");
            return `
                <tr>
                    <td>${idx + 1}</td>
                    <td>
                        <strong>${escapeHtml(row?.client_name || "Без імені")}</strong>
                        ${meta ? `<div class="meta">${escapeHtml(meta)}</div>` : ""}
                    </td>
                    <td class="amount">${escapeHtml(formatMoney(row?.debt_amount))} грн</td>
                </tr>
            `;
        }).join("")
        : `<tr><td colspan="3" class="empty">Немає клієнтів із боргом</td></tr>`;

    const html = `<!doctype html>
<html lang="uk">
<head>
  <meta charset="utf-8" />
  <title>${escapeHtml(title)}</title>
  <style>
    @page { margin: 16mm; }
    body {
      font-family: "Segoe UI", Arial, sans-serif;
      color: #1f2937;
      margin: 0;
      padding: 24px;
    }
    h1 { margin: 0 0 6px; font-size: 20px; }
    .sub { color: #6b7280; font-size: 12px; margin-bottom: 16px; }
    table { width: 100%; border-collapse: collapse; }
    th, td { border-bottom: 1px solid #e5e7eb; padding: 10px 8px; text-align: left; vertical-align: top; }
    th { font-size: 12px; text-transform: uppercase; letter-spacing: 0.03em; color: #6b7280; }
    td { font-size: 13px; }
    .meta { color: #6b7280; font-size: 11px; margin-top: 2px; }
    .amount { white-space: nowrap; font-weight: 700; text-align: right; }
    .empty { text-align: center; color: #6b7280; }
    .footer {
      margin-top: 16px;
      display: flex;
      justify-content: space-between;
      gap: 12px;
      font-size: 13px;
      font-weight: 700;
    }
    .actions { margin: 0 0 16px; }
    .actions button {
      border: 1px solid #d1d5db;
      background: #111827;
      color: #fff;
      border-radius: 8px;
      padding: 8px 14px;
      cursor: pointer;
      font-size: 13px;
    }
    @media print {
      .actions { display: none; }
      body { padding: 0; }
    }
  </style>
</head>
<body>
  <div class="actions">
    <button type="button" onclick="window.print()">Друкувати / Зберегти PDF</button>
  </div>
  <h1>${escapeHtml(title)}</h1>
  <div class="sub">
    ${networkName ? `${escapeHtml(networkName)} · ` : ""}Сформовано: ${escapeHtml(generatedAt)}
  </div>
  <table>
    <thead>
      <tr>
        <th style="width:40px">#</th>
        <th>Клієнт</th>
        <th style="text-align:right">Борг</th>
      </tr>
    </thead>
    <tbody>${bodyRows}</tbody>
  </table>
  <div class="footer">
    <span>Усього боржників: ${rows.length}</span>
    <span>Сума боргу: ${escapeHtml(formatMoney(total))} грн</span>
  </div>
  <script>
    window.addEventListener("load", function () {
      setTimeout(function () { window.focus(); }, 50);
    });
  </script>
</body>
</html>`;

    const printWindow = window.open("", "_blank", "noopener,noreferrer,width=900,height=700");
    if (!printWindow) {
        throw new Error("Не вдалося відкрити вікно експорту. Дозвольте спливаючі вікна.");
    }
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
}
